import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import User from 'models/user/user.model';
import { OrganizationUnitService } from 'services/organization-unit/organization-unit.service';
import { UserService } from 'services/user/user.service';

@Component({
  selector: 'app-get-organization-unit',
  templateUrl: './get-organization-unit.component.html',
  styleUrls: ['./get-organization-unit.component.scss'],
})
export class GetOrganizationUnitComponent implements OnInit, OnDestroy {
  public organizationUnit: OrganizationUnit = new OrganizationUnit();
  public user: User = new User();

  private userSubscription: Subscription;
  private ouSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public userService: UserService,
    public router: Router,
    public organizationUnitService: OrganizationUnitService,
  ) { }

  async ngOnInit() {
    this.userSubscription = this.userService.getCurrentUser().subscribe((user) => this.user = user);
    this.ouSubscription = this.organizationUnitService.getOuList().subscribe((list) => {
      const fltr: OrganizationUnit[] = list.filter((ou) => ou.id === this.route.snapshot.paramMap.get('id'));
      if (fltr.length > 0) {
        this.organizationUnit = fltr[0];
      }
    });
    await this.organizationUnitService.list();
  }
  
  layers() {
    this.router.navigate([`/arcgis/layer/add/ou/${this.organizationUnit.id}`]);
  }

  async ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.ouSubscription) {
      this.ouSubscription.unsubscribe();
    }
  }
}
